import React, { FC } from "react";
import { ErrorContainer } from "./styled-components";
import { Icon } from "../Icon";
import { Paragraph } from "../Typography";

export const Error: FC = ({ children }) => (
  <ErrorContainer>
    <Icon name="error" size="s" />
    <Paragraph qaLabel="label-error-image" ml="space-1">
      {children as string}
    </Paragraph>
  </ErrorContainer>
);
